function home() {
    const revealSections = document.querySelectorAll('[data-home-decision-paths], [data-home-newsletter], [data-home-partner]');

    if (revealSections.length) {
        if ('IntersectionObserver' in window) {
            const revealObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                });
            }, {threshold: 0.18});

            revealSections.forEach((section) => {
                section.classList.add('is-reveal-ready');
                revealObserver.observe(section);
            });
        } else {
            revealSections.forEach((section) => section.classList.add('is-visible'));
        }
    }

    document.addEventListener('growtypePostAjaxLoadMoreContent', function () {
        let settings = {};

        jQuery(document).ready(function ($) {
            $(".e-img").Lazy(settings);
        });
    });
}

export {home};
